import { get } from 'lodash';
import { appQueryParameters } from '@clubmed/utils';
import URI from 'urijs';
import * as routeBuilder from 'Routes/routeBuilder';
import {
  API_PAYMENT_STATUS_SUCCESS,
  PAYMENT_STATUS_FAILURE,
  PAYMENT_STATUS_SUCCESS,
} from 'Utils/payment/constants';
const {
  legacy: { be: BE_LEGACY_KEY },
  locale: LOCALE_KEY,
} = appQueryParameters;
export const handlePspResponse = ({
  response,
  queryParams,
  customerId,
  orderId,
  bookingStatus,
}: {
  response: PaymentStatusResponse;
  queryParams: ParsedUrlQuery;
  customerId: string;
  orderId: string;
  bookingStatus?: string;
}) => {
  const paymentResult = get(response, 'paymentStatus.finalPaymentResponse.payment.paymentStatus');
  const bookingId = get(response, 'paymentStatus.finalPaymentResponse.booking.bookingId');
  const paymentStatus =
    paymentResult === API_PAYMENT_STATUS_SUCCESS ? PAYMENT_STATUS_SUCCESS : PAYMENT_STATUS_FAILURE;
  let confirmationUrl;

  if (bookingStatus) {
    confirmationUrl = new URI(`/account/bookings/${bookingId}/payment-confirmation`)
      .query({
        paymentStatus,
        bookingStatusBeforePayment: bookingStatus,
        currency: get(response, 'paymentStatus.finalPaymentResponse.payment.currency'),
        amount: get(response, 'paymentStatus.finalPaymentResponse.payment.paymentAmount'),
        provider: get(response, 'paymentStatus.finalPaymentResponse.payment.providerId'),
        t: orderId,
        [LOCALE_KEY]: queryParams.locale,
      })
      .toString();
  } else {
    const params = {
      ...(bookingId
        ? {
            bi: bookingId,
          }
        : null),
      paymentStatus,
      ...(customerId
        ? {
            ui: customerId,
          }
        : null),
      selectedProposalId: queryParams.selectedProposalId,
      [LOCALE_KEY]: queryParams.locale,
      ...(queryParams.hasOwnProperty(BE_LEGACY_KEY)
        ? {
            [BE_LEGACY_KEY]: null,
          }
        : null),
    };
    confirmationUrl = routeBuilder.buildUrl('confirmation', {}, params);
  }

  window.location.replace(confirmationUrl);
};
